import './action_status.component.scss'
import {ActionStatus} from "../../model/ActionStatus";
import {getAbsoluteUrl} from "../../../utils/urlUtill";
import {OpportunityAction} from "../../../opportunity_actions/model/OpportunityAction";
import {ActionTypes} from "../../model/ActionType";
import {ACTION_SERVICE_NAME} from "../../../utils/names/serviceNames";
import {IScope} from "angular";
import {LocalDateTime, ZoneId} from "js-joda";
import {
    CancelMailDialogComponent
} from "../../../opportunity_actions/components/delete-user/cancel.mail.dialog.component";

interface OpportunityActionControllerScope extends IScope {
    actionStatusTitle: string;
    actionStatusIconUrl: string;
    availableButton: boolean;
}

export class ActionStatusComponent {

    static instance = {
        template: require('./action_status.component.html'),
        controller: [
            '$mdDialog',
            '$scope',
            ACTION_SERVICE_NAME,
            ActionStatusComponent
        ],
        bindings: {
            'action': '<',
            'status' : '<'
        }
    };

    private action: OpportunityAction;
    private status: ActionStatus;
    private actionStatusTitle: string;
    private actionStatusIconUrl: string;
    private availableButton: boolean;
    private background: string;

    constructor(private $mdDialog: angular.material.IDialogService,
                private $scope: OpportunityActionControllerScope) {
    }

    $onInit() {
        if (this.action === undefined) {
            this.actionStatusTitle = this.getActionStatusTitle(this.status);
            this.actionStatusIconUrl = this.getActionStatusIconUrl(this.status);
            this.background = this.setBackground(this.status);
        } else {
            this.actionStatusTitle = this.getActionStatusTitle(this.action.status);
            this.actionStatusIconUrl = this.getActionStatusIconUrl(this.action.status);
            this.availableButton = this.isAvailableButton();
            this.background = this.setBackground(this.action.status);
        }
    }

    getActionStatusIconUrl = (status: ActionStatus) => {
        return '/app/images/icons/' + this.getIconName(status);
    };

    private setBackground = (status: ActionStatus): string => {
        switch (status) {
            case ActionStatus.REJECTED:
            case ActionStatus.DIRECTMAILER_CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS:
                return 'rgb(251, 153, 163)';
            default:
                return 'rgba(0, 0, 0, 0.05)';
        }
    }

    private getActionStatusTitle = (status: ActionStatus): string => {
        switch (status) {
            case ActionStatus.EXECUTED:
                return 'Executed';
            case ActionStatus.REJECTED:
                return "Failed";
            case ActionStatus.EMAIL_OPENED:
                return "Email Opened";
            case ActionStatus.EMAIL_SENT:
                return "Email Sent";
            case ActionStatus.EMAIL_DELIVERED:
                return "Email Delivered";
            case ActionStatus.NEW:
                return "Mail Created.";
            case ActionStatus.SUBMITTED:
                return "Mail Submitted";
            case ActionStatus.SENDGRID_UNSUBSCRIBED:
                return 'Unsubscribed';
            case ActionStatus.SENDGRID_RESUBSCRIBED:
                return 'Resubscribed';
            case ActionStatus.DIRECTMAILER_DRY_RUN:
                return "Dry run";
            case ActionStatus.DIRECTMAILER_CANCELED:
                return "Cancelled";
            case ActionStatus.DIRECTMAILER_CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS:
                return "Non Deliverable Address";
            case ActionStatus.DIRECTMAILER_PRE_PRODUCTION:
                return "In pre-production";
            case ActionStatus.DIRECTMAILER_IN_MAILSTREAM:
                return "In mailstream";
            case ActionStatus.DIRECTMAILER_IN_PRODUCTION:
                return "In production";
            case ActionStatus.DIRECTMAILER_MARKED:
                return "Marked for delivery";
            case ActionStatus.DIRECTMAILER_USPS_FORWARDED:
                return "USPS forwarded";
            case ActionStatus.DIRECTMAILER_USPS_RETURNED_TO_SENDER:
                return "Returned to sender";
        }
        throw new Error(`Not handled email status: ${status} `)
    };

    private getIconName(status: ActionStatus): string {
        switch (status) {
            //email
            case ActionStatus.EXECUTED:
                return 'bell.svg';
            case ActionStatus.REJECTED:
                return "close.svg";
            case ActionStatus.NO_EMAIL:
                return "close.svg";  //todo !!!
            case ActionStatus.EMAIL_OPENED:
                return "open_email.svg";
            case ActionStatus.EMAIL_SENT:
                return "sent.svg";
            case ActionStatus.EMAIL_DELIVERED:
                return "mail_outlined.svg";
            case ActionStatus.NEW:
                return "new.svg";
            case ActionStatus.SUBMITTED:
                return "ok.svg";
            //email subscription actions
            case ActionStatus.SENDGRID_UNSUBSCRIBED:
                return 'unsubscribe.svg';
            case ActionStatus.SENDGRID_RESUBSCRIBED:
                return 'resubscribed.svg';
            //direct mail
            case ActionStatus.DIRECTMAILER_CANCELED:
                return "canceled.svg";
            case ActionStatus.DIRECTMAILER_MARKED:
                return "marked_for_delivery.svg";
            case ActionStatus.DIRECTMAILER_PRE_PRODUCTION:
                return "pre_production.svg";
            case ActionStatus.DIRECTMAILER_IN_PRODUCTION:
                return "production.svg";
            case ActionStatus.DIRECTMAILER_IN_MAILSTREAM:
                return "ok.svg";
            case ActionStatus.DIRECTMAILER_USPS_FORWARDED:
                return "forwarded.svg";
            case ActionStatus.DIRECTMAILER_USPS_RETURNED_TO_SENDER:
                return "returned_to_sender.svg";
            case ActionStatus.DIRECTMAILER_CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS:
                return "cancelled_due_to_non_deliverable_address.svg";
            case ActionStatus.DIRECTMAILER_DRY_RUN:
                return "dry_run.svg";
        }
        throw new Error('Not handled email status!')
    }

    private isAvailableButton() {
        return this.action.actionType === ActionTypes.DIRECT_MAILER
            && this.getAvailableDateFrom() < this.action.executionStarted
            && this.action.status != ActionStatus.DIRECTMAILER_CANCELED
            && this.action.status != ActionStatus.REJECTED
            && this.action.status != ActionStatus.DIRECTMAILER_CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS;
    }

    private getAvailableDateFrom() {
        return LocalDateTime.now(ZoneId.UTC).minusHours(1);
    }

    cancelMailSending = () => {
        let dialog = CancelMailDialogComponent.instance(this.action);
        this.$mdDialog.show(dialog).then(
            () => {
                this.availableButton = false;
                this.action.status = ActionStatus.DIRECTMAILER_CANCELED;
                this.actionStatusTitle = this.getActionStatusTitle(this.action.status);
                this.actionStatusIconUrl = this.getActionStatusIconUrl(this.action.status);
                this.background = this.setBackground(this.action.status);
                },
            () => {
                console.log('Mail canceling was stopped');
            }
        );
    };
}